import { Route } from '@angular/router';

export const orderDetailLayoutRoutes: Route[] = [];
